export default {
  venueEditTabSafetyFeature: 'Safety instructions',
  venueCreateTabSafetyFeature: 'Safety instructions',
};
